module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-12.f458015c.png";